

<div class="dropdown custom-dropdown">
    <button class="btn btn-link p-0 three-dots-btn" type="button" id="dropdownMenuButton" (click)="toggleDropdown($event)">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-horizontal">
            <circle cx="12" cy="12" r="1"></circle>
            <circle cx="19" cy="12" r="1"></circle>
            <circle cx="5" cy="12" r="1"></circle>
        </svg>
        <span class="tooltip-text">More</span>
    </button>
    <div *ngIf="visibleMenuItems.length > 0" class="dropdown-menu" [class.show]="isDropdownOpen" (click)="$event.stopPropagation()">
        <ng-container *ngFor="let menuItem of visibleMenuItems">
            <button class="dropdown-item" (click)="onMenuItemClick(menuItem.id, $event)">
                <span 
                      [innerHTML]="menuItem.svg ? menuItem.svg(context) : ''"
                      class="menu-icon">

                </span>
                {{ menuItem.text(context) }}
            </button>
        </ng-container>
    </div>

    <!--<div class="dropdown-menu" [class.show]="isDropdownOpen" (click)="$event.stopPropagation()">
        <ng-container *ngIf="isUserPost">
            <button class="dropdown-item text-danger" (click)="deletePost()">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6L5 6M10 11L14 11M10 17L14 17M10 11L10 17M14 11L14 17M8 6V4C8 3.47 8.21 2.96 8.59 2.59C8.96 2.21 9.47 2 10 2H14C14.53 2 15.04 2.21 15.41 2.59C15.79 2.96 16 3.47 16 4V6M19 6L17 18.5C17 19.33 16.33 20 15.5 20H8.5C7.67 20 7 19.33 7 18.5L5 6"></path>
                </svg>
                Delete Post
            </button>
            <button class="dropdown-item" (click)="pinPost()">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-pin">
                    <path d="M18 2a2 2 0 1 1 4 4L4 24l-2 4 4-2L20 4a2 2 0 1 1-4-4Z"></path>
                </svg>
                Pin to your profile
            </button>
            <button class="dropdown-item" (click)="highlightPost()">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-star">
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                </svg>
                Highlight on your profile.
            </button>
            <div class="dropdown-divider"></div>
        </ng-container>

        <button class="dropdown-item" (click)="followUser($event)">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user-plus">
                <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="8.5" cy="7" r="4"></circle>
                <line x1="20" y1="8" x2="20" y2="14"></line>
                <line x1="23" y1="11" x2="17" y2="11"></line>
            </svg>
            {{ isFollowed ? 'Unfollow' : 'Follow' }} &#64;{{ postUsername }}
        </button>
        <button class="dropdown-item" (click)="muteUser()">
            <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" class="r-4qtqp9 r-yyyyoo r-1xvli5t r-dnmrzs r-bnwqim r-lrvibr r-m6rgpd r-1nao33i r-1q142lx">
                <g>
                    <path d="M18 6.59V1.2L8.71 7H5.5C4.12 7 3 8.12 3 9.5v5C3 15.88 4.12 17 5.5 17h2.09l-2.3 2.29 1.42 1.42 15.5-15.5-1.42-1.42L18 6.59zm-8 8V8.55l6-3.75v3.79l-6 6zM5 9.5c0-.28.22-.5.5-.5H8v6H5.5c-.28 0-.5-.22-.5-.5v-5zm6.5 9.24l1.45-1.45L16 19.2V14l2 .02v8.78l-6.5-4.06z">
                    </path>
                </g>
            </svg>
            Mute &#64;{{ postUsername }}
        </button>
        <button class="dropdown-item" (click)="blockUser()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-slash">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
            </svg>
            Block &#64;{{ postUsername }}
        </button>
    </div>-->
</div>
